<template>
    <div v-if='name && options' class='wrapper' v-prevent-scroll>
        <div class='dialog'>
            <h3>
                {{name.charAt(0).toUpperCase() + name.slice(1)}} Options
                <!-- Close -->
                <a class='pull-right clickable' title='Close' @click='close()'>
                    <img src="/images/X_large_dkGrey.svg">
                </a>
            </h3>

            <!-- Letter buttons -->
            <p class='btn-group' role='group' aria-label='...'>
                <button v-for='(value, letter) in options'
                    type='button'
                    class='btn btn-xs btn-default'
                    @click='viewing = letter'
                    :class="{'active': viewing == letter}">
                    {{letter}}
                </button>
            </p>

            <!-- Options -->
            <div>
                <div class='btn-group' role='group' aria-label='...'>
                    <button type='button'
                        class='btn btn-sm btn-default'
                        @click='numeric_sort = true'
                        :class="{'active': numeric_sort == true}">
                        Frequency
                    </button>
                    <button type='button'
                        class='btn btn-sm btn-default'
                        @click='numeric_sort = false'
                        :class="{'active': numeric_sort == false}">
                        Alphabetically
                    </button>
                </div>
            </div>

            <div v-show='!loading' class='options'>
                <div v-for='option in sort(options[viewing], numeric_sort)'>
                    <label>
                        <input :id='option.key'
                            v-model='manager.filters[name].selected'
                            :value='option.key'
                            type="checkbox"
                            @click='fetchAll(name)'/>
                        <label :for='option.key'></label> {{manager.cleanHtml(option.key)}} ({{option.doc_count}})
                    </label>
                </div>
            </div>
            <p v-show='error'>An error has occured. Please Try again later.</p>
            <div v-show='loading' class='loader'>
                <img src="/images/mariners-loading-icon.gif" width='35px'>
            </div>
        </div>
    </div>
</template>

<script>
    import EventHub from '../eventHub.js'
    import FilterManager from './../filterManager.js'

    export default {
        props: ['filterResults'],
        created: function () {
            EventHub.$on('see-all-options', this.fetchAll)
        },
        data: function () {
            return {
                manager: FilterManager,
                name: null,
                options: [],
                viewing: null,
                loading: true,
                numeric_sort: true
            }
        },
        beforeDestroy: function () {
            EventHub.$off('see-all-options')
        },
        methods: {
            sort: function (list, numeric) {
                var self = this

                if (numeric == true) {
                    list = _.orderBy(list, ['doc_count'], ['desc'])
                }

                return list
            },
            close: function () {
                this.name = null
                this.filterResults()
            },
            fetchAll: function (facet) {
                var self = this
                this.loading = true
                this.name = facet

                var params = $.extend(true, {}, FilterManager.generateQuery())
                params.facet = facet
                params.agg_limit = 1000000
                params.agg_chunk = true

                // Make request for new facets
                $.get('/api/objects', params).done(function (response) {
                    response = $.parseJSON(response)

                    if (response.aggs) {
                        self.options = response.aggs[facet].buckets
                        if (self.viewing == null) {
                            self.viewing = Object.keys(self.options)[0]
                        }
                        self.loading = false

                        return
                    }

                    this.error = true
                })
            },
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../../sass/variables.scss';

    .wrapper {
        background-color: rgba(0, 0, 0, 0.6);
        position: fixed;
        z-index: 105;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .dialog {
        background-color: white;
        width: 50%;
        overflow-y: auto;
        margin-right: auto;
        margin-left: auto;
        margin-top: 100px;
        padding: 20px;

        // rounded corners
        -webkit-border-radius: 5px 5px 5px 5px;
        -moz-border-radius: 5px 5px 5px 5px;
        border-radius: 5px 5px 5px 5px;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            width: 90%;
        }

        h3 {
            margin-top: 0;
        }
    }

    .options {
        white-space: nowrap;
        max-height: 300px;
        margin-top: 20px;
        overflow-y: auto;
        overflow-x: auto;
    }

</style>
